$(window).ready(function () {
    // if ($('.slide-countdown').length) {
    //     var wrapper = $('.slide-countdown'),
    //         countDown = wrapper.data('countdown'),
    //         countDownDate = new Date(countDown).getTime(),
    //         countDownText = window.countdown.text;

    //     if (wrapper.length > 0) {
    //         var countdownfunction = setInterval(function () {
    //             var now = new Date().getTime(),
    //                 distance = countDownDate - now;

    //             if (distance < 0) {
    //                 clearInterval(countdownfunction);
    //                 wrapper.remove();
    //             } else {
    //                 var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
    //                     hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    //                     minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
    //                     seconds = Math.floor((distance % (1000 * 60)) / 1000),
    //                     strCountDown;

    //                 if (wrapper.is('.style-2, .style-3')) {
    //                     strCountDown = '<span class="text"><span>' + countDownText + '</span></span><span class="num">' + days + '<span>' + window.countdown.day_2 + '</span></span>\
    //                             <span class="num">'+ hours + '<span>' + window.countdown.hour_2 + '</span></span>\
    //                             <span class="num">'+ minutes + '<span>' + window.countdown.min_2 + '</span></span>\
    //                             <span class="num">'+ seconds + '<span>' + window.countdown.sec_2 + '</span></span>';
    //                 }
    //                 else {
    //                     strCountDown = '<span class="text"><span>' + countDownText + '</span></span><span class="num">' + days + '<span>' + window.countdown.day + '</span></span>\
    //                             <span class="num">'+ hours + '<span>' + window.countdown.hour + '</span></span>\
    //                             <span class="num">'+ minutes + '<span>' + window.countdown.min + '</span></span>\
    //                             <span class="num">'+ seconds + '<span>' + window.countdown.sec + '</span></span>';
    //                 }

    //                 wrapper.html(strCountDown);
    //                 wrapper.addClass('show');
    //             }
    //         }, 1000);
    //     }
    // }

    $('.mobile-search-bar').on('click', function() {
        $(document.body).addClass('open_search_mobile');
        setTimeout(function() { $('#search-form-mobile .search__input').focus(); }, 350);
    });

    /*Complementary Auto Set Size*/

    // const variantRadioComponent = document.querySelector('variant-radios');
  
    // variantRadioComponent.addEventListener('sizeChange', function(event) {
    //   const sizeValue = event.detail.size;
    //   changeAllSizeOfComplementary(materialValue);
    // });
    
    // function changeAllSizeOfComplementary(size) {
  
    //   const complementaryProducts = document.querySelectorAll('complementary-products select[data-option-name="Size"]');
    //   if (!complementaryProducts.length) return;
    
    //   complementaryProducts.forEach(complementary => {
    //       Array.from(complementary.options).forEach(option => {
    //         if (option.text.includes(size)) {
    //           complementary.value = option.value;
    //         }else{
    //           option.setAttribute('disabled')
    //         }
    //       });
    //   });
    // }
});